import Baobab from 'baobab'

const tree = new Baobab({
    instances: [],
    keycloak: {},
});

(window as any).tree = tree;

export default tree;